/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com`;
export const GOOGLE_MAPS_LINK = `https://goo.gl/maps/P7NxyyS6xTKCrEzG9`;

/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1733653800;
export const EPOCH_END_EVENT = 1733653800;
export const UTC_WEDDING_TIME = '2024-12-08:10:30:00Z';
